// ユーザ詳細画面
import * as React from 'react';
import { Table, Button, Form, Input, Message } from 'element-react';
import * as moment from 'moment';
import { Inquiry, InquiryAnswer } from '../interfaces';
import Back from './common/Back';
import 'element-theme-default';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/user_detail.css';
import '../css/input.css';

interface InquiryDetailProps extends React.Props<{}> {
  headerActions?: any;
  moffAPIActions: any;

  match?: any;
  moffAPI: any;
}

interface DetailState {
  inquiry: Inquiry;
  inquiryAnswers: InquiryAnswer[];
  columns: any;
}

export default class InquiryDetails extends React.Component<
  InquiryDetailProps,
  DetailState
  > {
  static get childContextTypes() {
    return {
      // callbackParent: PropTypes.func,
    };
  }

  inquiryId: string;
  answerForm = {
    answer: '',
  };

  relatedTableHeader: {} = {
    answers: '履歴'
  };

  constructor(props: InquiryDetailProps) {
    super(props);

    this.state = {
      inquiry: {
        inquiryId: '',
        inquiryNumber: 0,
        userId: '',
        username: '',
        question: '',
        isNew: false,
        createdAt: '',
        updatedAt: '',
        isClosed: false,
        answers: [],
      },
      inquiryAnswers: [],
      columns: {
        answers: [
          {
            label: 'ユーザID',
            prop: 'username',
            width: 180,
            sortable: true
          },
          {
            label: '内容',
            prop: 'answer',
            width: 360
          },
          {
            label: '日時',
            prop: 'createdAt',
            width: 180,
            sortable: true
          },
          /*
          {
            label: '役割',
            prop: 'role',
            width: 180,
            sortable: true
          },
          {
            label: 'userId',
            prop: 'userId',
            width: 180,
            sortable: true
          },
          */
        ]
      },
    };
  }

  runAPI() {
    this.props.moffAPIActions.getInquiryDetails(this.inquiryId);
    this.props.moffAPIActions.getUserId();
    this.props.moffAPIActions.getUserName();
  }

  componentWillMount() {
    this.inquiryId = this.props.match.params.inquiryId;
    document.title = '問い合わせ詳細画面';
    this.props.headerActions.setPage('INQUIRY_DETAIL');
    // 最初に一回通信.
    this.runAPI();
    setTimeout( () => {
      this.initInquiryData();
    }, 5000);
  }

  initInquiryData() {
    this.setState({
      inquiry: this.props.moffAPI.inquiryDetails
    });
    // if (this.state.inquiry.answers !== undefined) {
    this.setState({
      inquiryAnswers: this.state.inquiry.answers
    });
    // }
    console.log(this.state.inquiry);
    console.log(this.state.inquiryAnswers);
    console.log(this.props.moffAPI.loginedUserId);
    console.log(this.props.moffAPI.loginedUserName);
  }

  addAnswer() {
    if (this.answerForm.answer.length > 3 ) {
      const newInquiry = {
          ...this.state.inquiry,
          answers: [
            ...this.state.inquiryAnswers,
            {
              // userId: this.props.moffAPI.loginedUserId,
              username: this.props.moffAPI.loginedUserName,
              answer: this.answerForm.answer,
              createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
              role: 'operator'
            }
          ] 
      };
      console.log(newInquiry);
      this.props.moffAPIActions.putUpdateInquiry(newInquiry);
      Message({
        type: 'success',
        duration: 5000,
        message: '問い合わせに返答しました'
      });
      this.answerForm.answer = '';
      setTimeout( () => {
        this.initInquiryData();
      }, 3000);
      setTimeout( () => {
        this.forceUpdate();
      }, 3000);
    } else {
      Message({
        type: 'error',
        duration: 3000,
        message: '返答に失敗しました'
      });
    }
  }

  onChange(key: string, value: any) {
    this.answerForm.answer = value;

    const newInquiry = {
      ...this.state.inquiry,
      answers: [
        ...this.state.inquiryAnswers,
        {
          // userId: this.props.moffAPI.loginedUserId,
          username: this.props.moffAPI.loginedUserName,
          answer: this.answerForm.answer,
          createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
          role: 'operator'
        }
      ] 
    };
    console.log('onChange');
    console.log(newInquiry);
    this.forceUpdate();
  }

  onSubmit() {
    this.addAnswer();
  }

  render() {
    console.log('render() in InquiryDetails');
    let className: string = 'detail-wrap';
    let userMetas = [];

    if (this.props.moffAPI.Loaded) {
      const details = this.props.moffAPI[`inquiryDetails`];
      console.log(details);
      for (const key in details) {
        if (details.hasOwnProperty(key)) {
          if (key === 'answers') {
            continue;
          }
          if (key === 'inquiryNumber') {
            userMetas.push(
              <tr key={key}>
                <th>問い合わせ番号</th>
                <td>{details[key]}</td>
              </tr>
            );
            continue;
          }
          if (key === 'inquiryId') {
            {/*
            userMetas.push(
              <tr key={key}>
                <th>inquiryId</th>
                <td>{details[key]}</td>
              </tr>
            );
            */}
            continue;
          }
          if (key === 'isNew') {
            userMetas.push(
              <tr key={key}>
                <th>新着</th>
                <td>{details[key] ? 'New' : ''}</td>
              </tr>
            );
            continue;
          }
          if (key === 'question') {
            userMetas.push(
              <tr key={key}>
                <th>問合せ内容</th>
                <td>{details[key]}</td>
              </tr>
            );
            continue;
          }
          if (key === 'userId') {
            {/*
            userMetas.push(
              <tr key={key}>
                <th>システムID</th>
                <td>{details[key]}</td>
              </tr>
            );
            */}
            continue;
          }
          if (key === 'username') {
            userMetas.push(
              <tr key={key}>
                <th>ユーザID</th>
                <td>{details[key]}</td>
              </tr>
            );
            continue;
          }
          if (key === 'isClosed') {
            /*
            userMetas.push(
              <tr key={key}>
                <th>クローズ</th>
                <td>{details[key] ? 'クローズ済' : '未'}</td>
              </tr>
            );
            */
            continue;
          }
          userMetas.push(
            <tr key={key}>
              <th>{key}</th>
              <td>{details[key]}</td>
            </tr>
          );
        }
      }
    }

    return (
      <div>
        <style type="text/css">
          {/* 縦印刷, 日付・title名ヘッダの余白 */}
          {'@media print{@page {size: portrait; margin-top: 43px;}}'}
          {'@media print{#wrapper { padding:0; margin: 0; } header { display: none; }}'}
          {'@media print{.contentIn { padding-top:0!important; padding-bottom:0!important; }}'}
          {'@media print{.report { padding-bottom:0!important; }}'}
          {/* Edge対策 */}
          {'@media print{tr { page-break-inside: avoid; }}'}
          {'#wrapper .contentIn { padding-top: 80px; }'}
          {'h3 { margin-top: 15px; }'}
          {'h3 small { font-size: 13px;color: gray; margin: 8px 0;}'}
          {'.related-table h3 { display: flex; align-items: center;}'}
          {'.related-table h3 .btnStyle02 {margin-left: 16px;}'}
        </style>

        <Back />

        {/* inquiry */}
        <article className={className}>
          <div className="user">
            <table>
              {userMetas}
            </table>
          </div>
        </article>

        {/* inquiry.answers */}
        <Table
          style={{ width: '100%' }}
          columns={this.state.columns.answers}
          data={this.state.inquiryAnswers}
          border={false}
        />

        <br />

        {/* 返信内容 */}
        <Form model={this.answerForm} labelWidth="120">
          <Form.Item label="返答">
              <Input type="textarea" rows={5} value={this.answerForm.answer} placeholder="返答をここに記入" onChange={this.onChange.bind(this, 'answer')} />
              <Button type="primary" size="large" onClick={() => this.onSubmit()}>返答を送信</Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InquiryDetails.tsx